import React from 'react';
import { Redirect } from 'react-router-dom';
import withSplashMessage from '../splashMessage/withSplashMessage';
import DetailsBar from '../shared/DetailsBar';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import {
  maskCapitalizeFirstLetter,
  maskPrependComma,
  maskServiceDate,
  maskServiceEndTime,
  maskServiceStartTime
} from '../../masks';
import { stringfyServerErrors } from '../../helpers/util';
import TextAreaView from '../shared/TextAreaView';
import { chefAPI } from '../../InterfaceAPI/chefAPI';
import ChefDeclineOpportunityModal from './ChefDeclineOpportunityModal';
import ModalEnabled from '../extend/ModalEnabled';
import BackButton from '../shared/BackButton';
import { generateContent } from '../../helpers/plunger';
import ConfirmModal from '../shared/ConfirmModal';
import withTracker from '../withTracker';
import { isOccasion } from '../../helpers/serviceUtil';

class ChefServiceOpportunity extends ModalEnabled {
  detailsBarProperties = [
    {
      label: 'Service Date & Time',
      className: 'p',
      combine: [
        { key: 'date', mask: maskServiceDate },
        { raw: ' ', className: '--new-line' },
        { key: 'start_time', mask: maskServiceStartTime },
        { key: 'end_time', mask: maskServiceEndTime }
      ]
    },
    { label: 'Location', key: 'address', dive: 'zip_code' },
    {
      label: 'Service Type',
      key: 'service_type',
      sortable: false,
      mask: maskCapitalizeFirstLetter
    }
  ];

  state = {
    service: {}
  };

  render() {
    const { service } = this.state;
    const { client = {} } = service;
    const { client_101 = ' ' } = client;

    const detailsBarProperties = [...this.detailsBarProperties];

    if ('sevice_type' in service && isOccasion(service))
      detailsBarProperties.push({
        label: 'Number of Guests',
        dive: 'guest_number',
        className: 'p --capitalize'
      });

    if (['weekly', 'custom_weekly'].includes(service.service_type))
      detailsBarProperties.push({
        label: 'Portion Size',
        key: 'portion_size',
        className: 'p --capitalize'
      });

    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;

    return (
      <div className="cms cms--public">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/chef-profile" />
            <div className="cms__bar cms__bar--wrap">
              <div className="cms__user-heading">
                <HeadingPlaceholder value="Service Opportunity Details" />
              </div>
              <div className="cms__bar-ctas">
                <button
                  type="button"
                  className="btn btn--hollow-red-bright btn--full-mobile"
                  onClick={() => this.openModal('decline-service')}
                >
                  Decline
                </button>
                <button
                  type="button"
                  className="btn btn--solid-blue btn--full-mobile"
                  onClick={() => this.openModal('accept-service')}
                >
                  Accept
                </button>
              </div>
            </div>
            <DetailsBar data={service} columns={detailsBarProperties} />
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <div className="cms__section">
                  <div className="cms__bar cms__section-head">
                    <div className="cms__bar-left">
                      <h3 className="h3">Client Details</h3>
                    </div>
                  </div>
                  <div className="cms__section-body">
                    <div className="">
                      <p className="p p--bold">Diet</p>
                      {generateContent(client, {
                        key: 'client',
                        dive: ['dietary_preference_tags', 'tag']
                      })}
                    </div>
                    <div className="p--pad-top">
                      <p className="p p--bold">Allergens</p>
                      {generateContent(client, {
                        combine: [
                          { key: 'allergen_tags', dive: 'tag' },
                          { key: 'other_allergens', mask: maskPrependComma }
                        ]
                      })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row__item row__item--half row__item--pad-left">
                <TextAreaView
                  title="Client 101"
                  isEdit={false}
                  value={client_101}
                />
              </div>
            </div>
          </div>
        </div>

        {this.isOpen('decline-service') && (
          <ChefDeclineOpportunityModal
            isOpen={this.isOpen('decline-service')}
            closeModal={this.closeModal}
            opportunity={{ service }}
            onSubmit={this.handleDeclineService}
          />
        )}

        {this.isOpen('accept-service') && (
          <ConfirmModal
            isOpen={this.isOpen('accept-service')}
            closeModal={this.closeModal}
            onSubmit={this.handleAcceptService}
            heading="Accept Service"
            body="Are you sure? You will have access to the Materials (client info, menu, grocery list & recipes) for this job at least 48 hours prior to service."
            cta="Okay"
          />
        )}
      </div>
    );
  }

  handleDeclineService = () => {
    const {
      service,
      chefId = 0,
      redirect_url = `/chef-profile/${chefId}`
    } = this.state;
    const { id: serviceId = 0 } = service;

    if (chefId > 0 && serviceId > 0) {
      chefAPI
        .declineService(chefId, serviceId)
        .then(response => {
          this.props.addMessage({
            className: 'success',
            message: `Service has been declined.`
          });
          this.setState({ redirect_to: redirect_url });
        })
        .catch(err => {
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(err)
          });
          this.closeModal();
        });
    }
  };

  handleAcceptService = () => {
    const {
      service,
      chefId = 0,
      redirect_url = `/chef-profile/${chefId}`
    } = this.state;
    const { id: serviceId = 0 } = service;

    if (chefId > 0 && serviceId >= 0) {
      chefAPI
        .acceptService(chefId, serviceId)
        .then(response => {
          this.props.addMessage({
            className: 'success',
            message: `Service has been accepted!`
          });
          this.setState({ redirect_to: redirect_url });
        })
        .catch(err => {
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(err)
          });
        });
    }
  };

  componentDidMount() {
    const { state = {} } = this.props.location;
    this.setState(state);
  }
}
export default withSplashMessage(withTracker(ChefServiceOpportunity));



// WEBPACK FOOTER //
// ./src/components/chef/ChefServiceOpportunity.js